import React, { FC } from "react"
import { TaglineProps } from "./Tagline.types"

import "./Tagline.scss"

const Tagline: FC<TaglineProps> = ({
    vertical,
    mobile,
    className,
    ...props
}: TaglineProps) => {
    let klass = `zb-tagline ${className ?? ""}`
    if (vertical) klass += " zb-tagline-vertical"

    if (mobile) klass += " zb-is-mobile"

    return (
        <span
            className={klass}
            role="img"
            aria-label="Tomorrow Begins Today"
            {...props}
        ></span>
    )
}

export default Tagline
